import React from 'react';
import ClientCompanyProfilePage from '../components/CompanyProfile/CompanyProfilePage';

const ClientCompanyProfile = () => <ClientCompanyProfilePage />;

export default ClientCompanyProfile;
